import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import AcademyPage from "./pages/AcademyPage";
import CertificatePage from "./pages/CertificatePage";
import CertificateVerifyPage from "./pages/CertificateVerifyPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<AcademyPage />} />
          <Route path="/certificat/:certId" element={<CertificatePage />} />
          <Route path="/verifier/:certId" element={<CertificateVerifyPage />} />
          <Route path="/academy/verify/:certId" element={<CertificateVerifyPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
